module.exports = __webpack_public_path__ + "img/product_20.267496c.svg";